import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faCaretLeft, faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { CreNgModule } from 'cre-ng';
import { CarouselModule } from 'primeng/carousel';
import { SidebarModule } from 'primeng/sidebar';

import { CoreModule } from '@app/core';
import { FleetCompetitionResultsModule } from '@app/fleet-competition-results';
import { FleetScoreboardModule } from '@app/fleet-scoreboard';
import { SharedModule } from '@app/shared';
import { SportTeamLogoModule } from '@app/sport-team-logo';
import { WigWeeklyCompetitionDetailsComponent } from './wig-weekly-competition-details.component';
import { WigWeeklyCompetitionDetailsService } from './wig-weekly-competition-details.service';

@NgModule({
  declarations: [WigWeeklyCompetitionDetailsComponent],
  exports: [WigWeeklyCompetitionDetailsComponent],
  imports: [
    CarouselModule,
    CommonModule,
    CoreModule,
    CreNgModule,
    FleetCompetitionResultsModule,
    FleetScoreboardModule,
    FontAwesomeModule,
    SharedModule,
    SidebarModule,
    SportTeamLogoModule
  ],
  providers: [WigWeeklyCompetitionDetailsService]
})
export class WigWeeklyCompetitionDetailsModule {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(faCaretLeft, faCaretRight, faTimes);
  }
}
